import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {RecoveryPasswordComponent} from "./recovery-password/recovery-password.component";
import {SignupComponent} from "./signup/signup.component";
import {IsLoggedGuard} from "../../providers/guards/is-logged.guard";

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate:[IsLoggedGuard]
    },
    {
        path: 'recovery',
        component: RecoveryPasswordComponent
    },
    {
        path: 'signup',
        component: SignupComponent,

    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {

}
